<template>
  <!-- Sidebar -->
  <div class="sidebar" :class="{ mobile: isMobile }">
    <!-- <div
      class="sidebar-overlay"
      v-if="showSideBar"
      @click.stop="closeSidebar"
    ></div> -->

    <div class="sidebar__routers">
      <div class="sidebar-brand">
        <router-link
          v-show="isExpandSidebar"
          tag="a"
          to="/"
          class="navbar-brand"
        >
          NetOX
        </router-link>
        <div
          v-if="!isMobile"
          class="icon-wrapper"
          @click="toggleIsExpandSidebar"
        >
          <fa
            icon="angle-double-left"
            :class="{ 'fa-rotate-180': !isExpandSidebar }"
          ></fa>
        </div>
        <div v-else class="icon-wrapper" @click="toggleIsShowSidebarOnMobile">
          <fa icon="times"></fa>
        </div>
      </div>
      <ul class="sidebar-nav">
        <router-link
          tag="li"
          :to="`/apnic-at-a-glance/${query}`"
          :class="{ active: checkIsActive('apnic-at-a-glance') }"
        >
          <div class="icon-wrapper">
            <fa icon="eye"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-at-a-glance'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-rqc/${query}`"
          :class="{ active: checkIsActive('apnic-rqc') }"
        >
          <div class="icon-wrapper">
            <fa icon="tachometer-alt"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-rqc'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-routing/${query}`"
          :class="{ active: checkIsActive('apnic-routing') }"
        >
          <div class="icon-wrapper">
            <fa icon="server"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-routing'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-anti-abuse/${query}`"
          :class="{ active: checkIsActive('apnic-anti-abuse') }"
        >
          <div class="icon-wrapper">
            <fa icon="address-card"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-anti-abuse'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-database/${query}`"
          :class="{ active: checkIsActive('apnic-database') }"
        >
          <div class="icon-wrapper">
            <fa icon="database"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-database'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-geo/${query}`"
          :class="{ active: checkIsActive('apnic-geo') }"
        >
          <div class="icon-wrapper">
            <fa icon="globe"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-geo'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-activity/${query}`"
          :class="{ active: checkIsActive('apnic-activity') }"
        >
          <div class="icon-wrapper">
            <fa icon="file-medical-alt"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-activity'].name }}
            </span>
          </div>
        </router-link>

        <router-link
          tag="li"
          :to="`/apnic-comparison/${query}#tab=apnic-comparison`"
          :class="{ active: checkIsActive('apnic-comparison') }"
        >
          <div class="icon-wrapper">
            <fa icon="window-restore"></fa>
          </div>
          <div>
            <span class="nav-label">
              {{ $t('tabs')['apnic-comparison'].name }}
            </span>
          </div>
        </router-link>
      </ul>
    </div>
    <div class="sidebar-nav-links">
      <p v-show="isExpandSidebar">{{ $t('sidebar.usefulLinks') }}</p>
      <ul>
        <router-link tag="li" to="/disclaimer" active-class="active" exact>
          <div class="icon-wrapper">
            <fa icon="tools"></fa>
          </div>
          <div>
            <span class="nav-label">{{ $t('sidebar.disclaimer') }}</span>
          </div>
        </router-link>
        <router-link tag="li" to="/discover" active-class="active" exact>
          <div class="icon-wrapper">
            <fa icon="balance-scale"></fa>
          </div>
          <div>
            <span class="nav-label">{{ $t('sidebar.discover') }}</span>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import vClickOutside from 'v-click-outside';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['isExpandSidebar']),
    ...mapGetters(['showSideBar', 'query']),
  },
  methods: {
    ...mapMutations(['setIsExpandSidebar']),
    onClickOutside(event) {
      if (
        window.innerWidth < 769 &&
        event.target.id !== 'menu-toggle' &&
        event.target.offsetParent &&
        event.target.offsetParent.id !== 'menu-toggle'
      ) {
        this.closeSidebar();
      }
    },
    closeSidebar() {
      if (document.querySelector('.icon-open').offsetWidth) {
        document.querySelector('#menu-toggle').click();
      }
    },
    toggleIsExpandSidebar() {
      this.setIsExpandSidebar(!this.isExpandSidebar);
    },
    toggleIsShowSidebarOnMobile() {
      this.$emit('onToggleIsShowSidebarOnMobile');
    },
    checkIsActive(val) {
      const path = this.$route.path;
      if (path.includes(val)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.sidebar {
  position: fixed;
  top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: calc(100vh - 40px);
  color: $background-white;
  background-color: $text-black;

  .sidebar-brand {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0;
    height: 3.75rem;
    border-bottom: 4px $text-light-blue solid;

    .navbar-brand {
      margin-left: 1rem;
      font-size: 1.5rem;
      width: initial;
      font-weight: 600;

      color: $text-black;
    }

    .icon-wrapper {
      margin-left: 0.5rem;
      width: 3rem;
      height: 3rem;
      line-height: 3rem;
      text-align: center;
      font-size: 1rem;
      color: $text-black;
      cursor: pointer;

      svg {
        transition: transform 0.5s;
      }
    }
  }

  .sidebar-nav-links {
    p {
      padding: 0.5rem 1rem;
      font-weight: 600;
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li,
  .expand__toggle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0rem 0;
    cursor: pointer;
    color: $background-white;

    & > div {
      display: inline-block;
      padding: 0;
      margin: 0;
    }

    .icon-wrapper {
      margin: 0 1rem;
      width: 2rem;
      text-align: center;
      color: #fff;
      font-size: 2rem;

      svg {
        width: 1.5rem;
        padding-bottom: 4px;
        border-top: 4px solid rgba($color: #000000, $alpha: 0);
        border-bottom: 4px solid rgba($color: #000000, $alpha: 0);
      }
    }

    a {
      text-decoration: none;
    }

    .active {
      svg {
        border-bottom: 4px solid $apnic-blue;
      }
    }

    &.active {
      font-weight: 600;
      svg,
      i {
        border-bottom: 4px solid $apnic-blue;
      }
    }

    span {
      height: 3rem;
      line-height: 3rem;
    }
  }

  li {
    &:hover {
      background-color: #333;
    }
  }

  .expand {
    display: flex;
    flex-direction: column;
    cursor: none;

    &:hover {
      background-color: #1a1a1a;
    }

    &__toggle {
      .ga__dashboard-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 5rem);
      }
    }

    &__list {
      display: block;
      overflow: hidden;
      width: 100%;
      height: 0;
      transition: height 0.5s;

      &.show-list {
        height: 6rem;
      }

      .expand__item {
        padding-left: 5rem;

        &.active {
          span {
            border-bottom: 4px solid $apnic-blue;
          }
        }
      }
    }
  }
}

.ga__alerts-btn {
  position: relative;
}
.badge--warning {
  position: absolute;
  display: inline-block;
  left: 4.5rem;
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  margin-top: 0.7rem;
  border-radius: 50%;
  background-color: $warning-red;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  text-indent: 0;
  text-align: center;
}

.mobile.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
}
</style>
